import { formatTicker } from '@toggle/toggle';

import { useEntities } from '~/hooks/use-entities';

import type { ConversationInventory } from '../services/inventory-service';

export const useFormattedInventory = (
  inventory: ConversationInventory | undefined
): ConversationInventory => {
  const entityTags = inventory?.entity?.items?.map(i => i.tag) ?? [];
  const snakes = inventory?.timeseries?.items?.map(i => i.snake) ?? [];
  const financialStatements =
    inventory?.['financial-statement']?.items?.map(i => i.tag) ?? [];

  const snakesEntityTags = snakes.map(snake => snake.split('.')[0]);
  const financialStatementsEntityTags = financialStatements.map(
    financialStatement => financialStatement.split('.')[0]
  );
  const { data: snakesData } = useEntities({ entityTags: snakesEntityTags });
  const { data: entitiesData } = useEntities({ entityTags });
  const { data: financialStatementsData } = useEntities({
    entityTags: financialStatementsEntityTags,
  });

  const formattedTickers = entitiesData.map(formatTicker);
  const formattedSnakes = snakesData.map(formatTicker);
  const formattedFinancialStatements =
    financialStatementsData.map(formatTicker);
  return {
    ...inventory,
    ...(formattedTickers.length > 0 && {
      entity: {
        items: formattedTickers.map(ticker => ({ tag: ticker })),
      },
    }),
    ...(formattedSnakes.length > 0 && {
      timeseries: {
        items: formattedSnakes.map(snake => ({ snake })),
      },
    }),
    ...(formattedFinancialStatements.length > 0 && {
      ['financial-statement']: {
        items: formattedFinancialStatements.map(financialStatement => ({
          tag: financialStatement,
        })),
      },
    }),
  };
};
